import { render, staticRenderFns } from "./table-products.vue?vue&type=template&id=6d338476&"
import script from "./table-products.vue?vue&type=script&lang=js&"
export * from "./table-products.vue?vue&type=script&lang=js&"
import style0 from "./table-products.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports